<template>
	<button class="Button materialElement" @click="emitClick">
		<slot />
	</button>
</template>

<script>
export default {
	methods: {
		emitClick: function(event) {
			this.$emit('click', event.target.value)
		},
	},
}
</script>

<style scoped>
button {
	background: #1bcbac;
	color: #fff;
	font-size: 14px;
	border-radius: 4px;
	border: none;
	box-shadow: 0 2px 4px 0px #bfbfbf;
	margin: 10px;
	text-transform: uppercase;
	padding: 8px 20px;
	cursor: pointer;
	outline: none;

	transition: background 0.2s;
}

button:hover {
	background: #159e85;
}
button:disabled {
	background: gray;
}

button.onlyText {
	color: black;
	background: transparent;
	box-shadow: none;
}
button.white {
	color: black;
	background: #f6f6f6;
}

button.onlyText:hover, button.white:hover {
	background: #eee;
}
button.onlyText:active, button.white:active {
	background: #ccc;
}
</style>
